import { Auth } from "aws-amplify";

export async function getAuthenticationHeaders() {
  const authUser = await Auth.currentAuthenticatedUser();
  const jwtToken = authUser.signInUserSession.idToken.jwtToken;

 return {
    headers: {
      "Content-Type": "application/json",
      Authorization: jwtToken,
    },
  };
};
